import ApiService from "./../services/api-service";
import { setbalance, balance } from "./../action/balance";
export const getBalance = (bal) => async (dispatch) => {
  dispatch(balance());
  try {
    if (bal) {
      const response = bal;
      localStorage.setItem("balance", response["result"]["wallets"][0]?.balance);
      localStorage.setItem("hbarBalance", response["result"]["wallets"][2]?.balance);
      localStorage.setItem("nearBalance", response["result"]["wallets"][3]?.balance);
      localStorage.setItem("maticBalance", 0);

      const b = response["result"];

      dispatch(
        setbalance({
          balance: b["wallets"][0].balance,
          hbarBalance: b["wallets"][2].balance,
          maticBalance: b["wallets"][1].balance,
          nearBalance: b["wallets"][3].balance,
          lastUpdated: b.lastUpdated,
        })
      );
    } else {
      const response = await ApiService.BALANCE();
      localStorage.setItem("balance", response["result"]["wallets"][0]?.balance);
      localStorage.setItem("hbarBalance", response["result"]["wallets"][2]?.balance);
      localStorage.setItem("maticBalance", response["result"]["wallets"][1]?.balance);
      localStorage.setItem("nearBalance", response["result"]["wallets"][3]?.balance);

      const b = response["result"];

      dispatch(
        setbalance({
          balance: b["wallets"][0].balance,
          hbarBalance: b["wallets"][2].balance,
          maticBalance: b["wallets"][1].balance,
          nearBalance: b["wallets"][3].balance,
          lastUpdated: b.lastUpdated,
        })
      );
    }
  } catch (error) {}
};
